import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const deleteCategoryAction = createAsyncThunk(
    'delete-category',
    async (data = null, { rejectWithValue }) => {
        try {
            const res = await axios.delete(`/admins/api/delete-restore-category?is_delete=${data.is_delete}`,{data})
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const deleteCategorySlice = createSlice({
    name: 'delete-category',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(deleteCategoryAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(deleteCategoryAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(deleteCategoryAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const deleteCategoryReducer = deleteCategorySlice.reducer    